import React from 'react';
import { TextOutput } from '../types';

interface TextViewerProps {
    data: TextOutput;
}

export const TextViewer: React.FC<TextViewerProps> = ({ data }) => {
    const renderMarkdown = (text: string) => {
        let html = text;

        html = html.replace(/^### (.*$)/gim, '<h3 class="text-lg font-semibold mt-4 mb-2">$1</h3>');
        html = html.replace(/^## (.*$)/gim, '<h2 class="text-xl font-bold mt-6 mb-3">$1</h2>');
        html = html.replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold mt-8 mb-4">$1</h1>');

        html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold">$1</strong>');
        html = html.replace(/\*(.*?)\*/g, '<em class="italic">$1</em>');

        html = html.replace(/^\- (.*$)/gim, '<li class="ml-4">$1</li>');
        html = html.replace(/(<li.*<\/li>)/s, '<ul class="list-disc ml-6 my-2">$1</ul>');

        html = html.replace(/\n\n/g, '<br/><br/>');
        html = html.replace(/\n/g, '<br/>');

        return html;
    };

    if (data.format === 'markdown') {
        return (
            <div 
                className="prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ __html: renderMarkdown(data.content) }}
            />
        );
    }

    if (data.format === 'html') {
        return (
            <div 
                className="prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ __html: data.content }}
            />
        );
    }

    return (
        <div className="whitespace-pre-wrap text-gray-800">
            {data.content}
        </div>
    );
};
